import { api } from 'app/config/apiConfig';
import { ContractItemPriceRaise, RejectContractItemPriceRaiseDto } from '../model/types';

export const rejectContractItemPriceRaiseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    rejectContractItemPriceRaise: builder.mutation<ContractItemPriceRaise, RejectContractItemPriceRaiseDto & { contractId: string }>({
      query: ({ contractId, ...body }) => ({
        url: `/contracts/${contractId}/price-raise/reject`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Contracts', 'Contract item price raises'],
    }),
  }),
});

export const { useRejectContractItemPriceRaiseMutation } = rejectContractItemPriceRaiseApi;
